import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BlobFileDownloadRequestModel } from '../../models/blob-file-sas-url.model';
import { SIDownloadCSV } from '../../models/si-download-csv.model';
import { SIReadyforPayment } from '../../models/si-ready-for-payment.model';
import { SettingsService } from '../common/settings.service';

@Injectable({
  providedIn: 'root'
})
export class SIDownloadReportService {
  constructor(
    private http: HttpClient,
    public settings: SettingsService
  ) {}

  getSIDownloadCSVFilesList(): Observable<SIDownloadCSV[]> {
    return this.http.get<SIDownloadCSV[]>(
      this.settings.baseUrl +
        'api/M365acceleratorNominations/GetSIDownloadCSVList'
    );
  }

  getSIDownloadCSVFile(
    downloadModal: BlobFileDownloadRequestModel
  ): Observable<string> {
    return this.http.post<string>(
      this.settings.baseUrl + 'api/M365acceleratorNominations/DownloadCSVFile',
      downloadModal
    );
  }

  getSIReadyforPaymentReport(
    hasPayeeId: boolean
  ): Observable<SIReadyforPayment[]> {
    return this.http.get<SIReadyforPayment[]>(
      this.settings.baseUrl +
        'api/M365acceleratorNominations/GetSIReadyforPaymentReport/hasPayeeId/' +
        hasPayeeId
    );
  }
}
